import { Component, Inject, Injector, OnInit } from "@angular/core";
import { PERSONAL_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { HelpTourService } from "@common/shell/help-tour/help-tour.service";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { BasicEmbedTour } from "app/services/basic-embed-tour";
import { Observable } from "rxjs";

@Component({
    selector: "adapt-personal-dashboard-page",
    templateUrl: "./personal-dashboard-page.component.html",
    standalone: false,
})
export class PersonalDashboardPageComponent extends BaseRoutedComponent implements OnInit {
    public personalConfigLink$: Observable<string>;

    constructor(
        injector: Injector,
        private tourService: HelpTourService,
        @Inject(PERSONAL_CONFIGURATION_PAGE) personalConfigurationPageRoute: IAdaptRoute<any>,
    ) {
        super(injector);

        this.personalConfigLink$ = personalConfigurationPageRoute.getRoute();
    }

    public async ngOnInit() {
        // if not within a timeout the dialog will disappear by itself when navigating to this page
        setTimeout(() => {
            // run tour if first visit
            if (!this.tourService.tourHasRun(BasicEmbedTour)) {
                this.runTour();
            }
        });
    }

    public runTour() {
        this.tourService.runTour(BasicEmbedTour);
    }
}
